<template>
  <div class="bg-white rounded-xl space-y-5 items-center w-full tableContainer">
    <el-table v-loading="isLoading" @row-click="showOrderDetail" :data="orders" style="width: 100%">
      <el-table-column width="50" prop="id" label="ID"> </el-table-column>
      <el-table-column prop="orderRef" label="Order ref"> </el-table-column>
      <el-table-column prop="dateCreated" :formatter="formatDatePipe" label="Date Created"> </el-table-column>
      <el-table-column prop="statusFormatted" label="Status"> </el-table-column>
      <el-table-column
        v-bind:key="template.label"
        v-for="template of templates"
        :label="template.label"
        :width="template.width"
      >
        <template #default="scope">
          {{ scope.row[template.props] }}
        </template>
      </el-table-column>
      <el-table-column label="Actions" width="150">
        <template #default="scope">
          <div class="flex" v-if="!updatingOrders[scope.row.orderRef]">
            <span
              v-on:click.stop="changeOrderState(scope.row, 'ready_to_submit')"
              v-if="scope.row.status.name === 'ready_to_submit'"
              title="Force Process Order"
              class="action-icons text-xl el-icon-video-play mr-2"
            ></span>
            <span
              v-on:click.stop="changeOrderState(scope.row, 'ready_to_submit')"
              v-if="scope.row.status.name === 'paused'"
              title="Resume Order"
              class="action-icons text-xl el-icon-video-play mr-2"
            ></span>
            <span
              v-on:click.stop="changeOrderState(scope.row, 'paused')"
              v-if="scope.row.status.name === 'ready_to_submit'"
              title="Temporarily stop Order"
              class="action-icons text-xl el-icon-video-pause mr-2"
            ></span>
            <span
              v-on:click.stop="changeOrderState(scope.row, 'ready_to_submit')"
              v-if="scope.row.status.name === 'submission_error'"
              title="Re-submit Order"
              class="action-icons text-xl el-icon-refresh mr-2"
            ></span>
            <el-popconfirm
              v-if="
                scope.row.status.name === 'ready_to_submit' ||
                scope.row.status.name === 'paused' ||
                scope.row.status.name === 'submission_error'
              "
              confirmButtonText="OK"
              cancelButtonText="No, Thanks"
              icon="el-icon-info"
              iconColor="red"
              title="This action is irreversible. Are you sure you want to proceed?"
              @confirm="changeOrderState(scope.row, 'deleted')"
            >
              <template #reference>
                <span title="Permanently Stop Order" class="action-icons text-xl el-icon-switch-button mr-2"></span>
              </template>
            </el-popconfirm>
          </div>
          <span v-if="updatingOrders[scope.row.orderRef]" class="text-xl el-icon-loading"></span>
        </template>
      </el-table-column>
    </el-table>

    <!--#region pagination  -->
    <div class="mt-6 text-center">
      <el-pagination
        class="inline-block"
        :page-size="parseInt(paginationInfo.per_page)"
        :pager-count="11"
        :current-page="paginationInfo.current_page"
        layout="prev, pager, next"
        :total="paginationInfo.total"
        @current-change="getOrders"
        v-if="paginationInfo && orders.length"
      >
      </el-pagination>
    </div>
    <!--#endregion -->
  </div>
</template>

<script lang="ts">
import { ElNotification } from 'element-plus';
import { defineComponent } from 'vue';
import router from '../app-router';
import { OrderClientModel } from '../models/client';
import { orderService } from '../services';
import { formatDate } from '../utils';

export default defineComponent({
  name: 'orders-table',
  props: {
    orders: Array,
    isLoading: Boolean,
    paginationInfo: Object,
    templates: Array,
  },
  data: function () {
    return {
      updatingOrders: {},
      ordersRef: [] as OrderClientModel[],
      total: 10,
    };
  },
  emits: ['orderReProcessed', 'paginate'],
  created() {
    this.ordersRef = this.orders as OrderClientModel[];
  },
  methods: {
    showOrderDetail: function (order) {
      router.push({ name: 'orderDetail', params: { id: order.id } });
    },
    async changeOrderState(order: OrderClientModel, state) {
      this.updatingOrders[order.orderRef] = true;
      try {
        await orderService.updateOrderQueueStatus(order.orderRef, state !== order.status.name ? state : '');
        this.$emit('paginate', this.paginationInfo ? this.paginationInfo.current_page : 1);
        this.$emit('orderReProcessed');
      } catch (e) {
        ElNotification({
          title: 'Error',
          type: 'error',
          message: 'Failed to change order status. Please try again later.',
          position: 'bottom-right',
        });
      } finally {
        delete this.updatingOrders[order.orderRef];
      }
    },
    formatDatePipe: function (order) {
      return formatDate(String(order.dateCreated));
    },
    getOrders: function (page = 1) {
      this.$emit('paginate', page);
    },
  },
});
</script>

<style lang="scss" scoped>
.tableContainer ::v-deep(tr) {
  cursor: pointer;
  text-transform: capitalize;
}

.action-icons:hover {
  margin-top: -1px;
}
</style>
